import { z } from "zod";
export const uuidSchema = z.uuid().describe("UUIDv7");
/**
 * Para: TRY kuruş cinsinden tam sayı, JSON'da DİZGE olarak taşınır ("123456" = 1.234,56 ₺).
 * Dizge olmasının nedeni: JSON sayıları float'tır ve bigint'i taşıyamaz (AGENTS.md §3.2).
 */
export const moneySchema = z
    .string()
    .regex(/^-?\d{1,19}$/, "Tutar kuruş cinsinden tam sayı dizgesi olmalıdır")
    .describe('TRY kuruş cinsinden tutar (dizge). Örn. "123456" = 1.234,56 ₺');
export const nonNegativeMoneySchema = moneySchema.refine((value) => !value.startsWith("-"), "Tutar negatif olamaz");
const decimalString = (scale, label) => z
    .string()
    .regex(new RegExp(`^-?\\d{1,15}(\\.\\d{1,${scale}})?$`), `${label} en fazla ${scale} ondalık basamaklı sayı dizgesi olmalıdır`);
/** Miktar (litre, kWh, kg, adet): numeric(18,3), dizge. */
export const quantitySchema = decimalString(3, "Miktar").describe('Miktar (dizge, en fazla 3 ondalık). Örn. "37.245"');
/** Birim fiyat: numeric(18,4), dizge. */
export const unitPriceSchema = decimalString(4, "Birim fiyat").describe('Birim fiyat (dizge, en fazla 4 ondalık). Örn. "43.2100"');
/** Oran (yüzde): dizge. */
export const rateSchema = decimalString(4, "Oran").describe('Yüzde oran (dizge). Örn. "20"');
/** Takvim günü: YYYY-MM-DD (iş günü, vade, belge tarihi). */
export const localDateSchema = z.iso.date().describe("Takvim günü (YYYY-MM-DD)");
/** Zaman damgası: ISO 8601, UTC. */
export const timestampSchema = z.iso.datetime({ offset: true }).describe("ISO 8601 zaman damgası (UTC)");
//# sourceMappingURL=primitives.js.map